import Icon from '../components/Icon.vue'

Icon.register({"bell":{"width":448,"height":512,"paths":[{"d":"M433.9 366.1C411.6 343.8 384 316.1 384 208 384 128.6 326.2 62.7 250.3 50.2A31.8-31.8 0 0 1 256 32C256 14.3 241.7 0 224 0S192 14.3 192 32C192 38.8 194.1 45 197.7 50.2 121.8 62.7 64 128.6 64 208 64 316.1 36.4 343.8 14.1 366.1-16 396.2 5.3 448 48 448H160C160 483.3 188.7 512 224 512S288 483.3 288 448H399.9C442.6 448 464.1 396.3 433.9 366.1zM224 472A8-8 0 0 0 224 488C201.9 488 184 470.1 184 448H200C200 461.2 210.8 472 224 472z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-awesome@3.0.0@vue-awesome/icons/bell.js
// module id = null
// module chunks = 